import clsx from "clsx";
import { FC, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

interface ConditionalTooltipProps {
  condition: boolean | undefined;
  children: ReactNode;
  className?: string;
}

export const ConditionalTooltip: FC<ConditionalTooltipProps> = ({
  condition,
  children,
  className,
}) => {
  return condition ? (
    <Tooltip>
      <TooltipTrigger className={clsx(className)}>
        <div>{children}</div>
      </TooltipTrigger>
      <TooltipContent>
        <FormattedMessage
          id="payment.tooltip"
          defaultMessage="Need to update payment method"
        />
      </TooltipContent>
    </Tooltip>
  ) : (
    <>{children}</>
  );
};
